var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-spacer",staticStyle:{"height":"120px !important"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('leftSideInfo'),_c('allDeals')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }